export default "__VITE_ASSET__DTSuY2Uk__"